<template>

<div class="main marquees">

	<div class="promotions-heading">
		<h1><router-link to="/promotionpacks">Promotion Packs</router-link><i class="fas fa-chevron-right"></i><router-link :to="'/promotionpacks/' + push_pack_id" tag="a" class="breadcrumb">{{ push_pack_name }}</router-link><i v-if="push_pack_name" class="fas fa-chevron-right"></i>Products</h1>
	</div>

	<div class="filters with-save">
		<label v-if="limitReached">Promotions packs are limited to {{ productLimit }} products</label>
		<label v-else>Add a product to this promotion pack</label>
		<label></label><label></label>
		<div style="display: grid; grid-template-columns: 3fr 1fr 1fr; grid-gap: 1em;">
			<div class="input-with-control">
				<input type="text" class="promotions" placeholder="Search products" v-model="search_text" @keyup.enter="searchProducts()">
				<div :class="['button', 'input-go', limitReached ? 'disabled' : 'promotions']" @click="searchProducts()"><i class="fas fa-search"></i></div>
			</div>
		</div>
		<div style="text-align: right;">{{ saveMessage }}</div>
		<div>
			<span :class="['button', saving ? 'disabled' : 'promotions']" style="float: right; margin: -0.5em 0 0 0;" @click="saveProducts()">Save Features</span>
		</div>
	</div>

	<div v-if="message" class="empty-list">
		{{ message }}
		<div v-if="loading" class="loading"><i class="fas fa-spinner fa-spin"></i></div>
	</div>

	<div v-if="products.length > 0" class="item-grid promotions">
		<div v-for="(product, index) in products" :key="index" class="feature-grid-item">
			<div style="text-align: center; position: relative;">
				<img v-if="product.display_flag > 0" :src="'/img/sale-badge-' + product.display_flag + '.png'" class="display-flag">
				<img :src="product.image_src">
			</div>
			<div class="caption">
				<div style="float: right;"><b>{{ product.upc }}</b></div>
				<div><b>{{ product.item_number }}</b></div>
				{{ product.description }}
			</div>
			<div class="feature-controls caption">
				<label>Dealer Price</label>
				<label>Retail Price</label>
				<label style="text-align: right;">Margin</label>
				<div>Default: ${{ product.current_cost }}</div>
				<div>Avg: ${{ product.customer_price }}</div>
				<div style="text-align: right;">{{ calculateMargin(product.current_cost, product.customer_price) }}</div>
				<input type="text" class="promotions" v-model="product.cost">
				<input type="text" class="promotions" v-model="product.price">
				<div style="text-align: right;">{{ calculateMargin(product.cost, product.price) }}</div>
			</div>
			<div style="display: grid; grid-template-columns: 1fr 3em; grid-gap: 2em; align-items: end;">
				<div class="caption">
					<label>Display Flag</label>
					<div>
						<select class="promotions" v-model="product.display_flag">
							<option v-for="(display_flag,index) in displayFlags" :key="index" :value="index">
								{{ display_flag }}
							</option>
						</select>
					</div>
				</div>
				<div class="button promotions" style="margin: 0 0 0.66em 0;" @click="removeProduct(product)">X</div>
			</div>
		</div>
	</div>

	<div v-if="showModal" class="modal">
		<div class="inner">
			<h2>Product Search Results</h2>
			<div class="content">
				<div v-if="modalList.length < 1" class="empty-list">
					No Products found for '{{ search_text }}'
				</div>
				<div v-else class="product-search-list">
					<div v-for="(product, index) in modalList" :key="index" @click="assignProduct(product)" class="product">
						<div class="image_wrapper">
							<img :src="product.image_src">
						</div>
						<span class="caption"><b>{{ product.item_number }}</b>: {{ product.description }}</span>
					</div>
				</div>
			</div>
			<div class="modal-controls">
				<div class="button cancel" @click="showModal = false">Cancel</div>
			</div>
		</div>
	</div>

</div>
</template>

<script>
export default {
	name: 'products',
	props: ['push_pack_id'],
	data() {
		return {
			loading: true,
			message: 'Loading',
			push_pack_name: '',
			products: [],
			displayFlags: {},
			productLimit: 20,
			search_text: '',
			modalList: [],
			showModal: false,
			modalMessage: '',
			saving: false,
			saveMessage: ''
		}
	},
	created() {
		this.getList()
	},
	watch: {

	},
	computed: {
		limitReached() {
			return this.products.length >= this.productLimit
		}
	},
	methods: {
		getList() {
			this.products = []
            this.loading = true
            this.message = 'Loading'
            this.apiCall({ destination: 'get_list_push_pack_products', data: { push_pack_id: this.push_pack_id } }).then(obj => {
                this.loading = false
                this.message = obj.message
                if (obj.status == 'success') {
					this.push_pack_name = obj.push_pack_name
                    this.products = obj.products
					this.displayFlags = obj.display_flags
                    if (this.products.length < 1) {
                        this.message = 'No products set for this promotion pack'
                    }
					if (obj.product_limit) {
						this.productLimit = obj.product_limit
					}
                }
            })
		},
		calculateMargin(cost, price) {
			if (cost > 0 && price > 0) {
				return (100 * (1 - (Number(cost) / Number(price)))).toFixed(1) + '%'
			} else {
				return ''
			}
		},
		searchProducts() {
			if (!this.search_text) { return }
			if (this.limitReached) { return }
			var productIds = []
			for (var i = 0; i < this.products.length; i++) {
				productIds.push(this.products[i]['product_id'])
			}
			this.apiCall({ destination: 'get_list_products', data: { search_text: this.search_text, ignore_ids: productIds } }).then(obj => {
				this.showModal = true
				this.modalMessage = obj.message
				this.modalList = obj.products
			})
		},
		assignProduct(product) {
			for (var i = 0; i < this.products.length; i++) {
				if (this.products[i]['product_id'] == product.product_id) {
					return
				}
			}
			this.products.push(product)
			this.message = ''
			this.modalMessage = ''
			this.showModal = false
			this.modalList = []
		},
		removeProduct(product) {
			for (var i = 0; i < this.products.length; i++) {
				if (this.products[i]['product_id'] == product.product_id) {
					this.products.splice(i, 1)
					break
				}
			}
		},
		saveProducts() {
			if (this.saving) { return }
			this.saving = true
			this.apiCall({ destination: 'save_push_pack_products', data: { push_pack_id: this.push_pack_id, products: this.products } }).then(obj => {
				this.saving = false
                this.saveMessage = obj.message
				setTimeout(() => { this.saveMessage = '' }, 3000)
			})
		}
	}
}
</script>
